import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { firestore } from '../../../firebase';
import { dateFormatterShort } from '../../../helpers/dateFormatter';
import { totalIncomeCalculator } from '../../../helpers/financeCalculator';
import StateContext from '../../../StateContext';
import AddTotalExpensesCategory from './AddTotalExpensesCategory';

function SingleCategory({type, categoryId, categoryName, month}) {

    const appState = useContext(StateContext);

    const [budget, setBudget] = useState([]);
    const [filteredBudget, setFilteredBudget] = useState([])
    const [show, setShow] = useState(true);

    useEffect(() => {

        if (appState.userId) {

            try {
                const budgetRef = firestore.collection("users").doc(appState.userId).collection("budget");
                budgetRef.orderBy("date", "desc").where("category", "==", categoryId).onSnapshot(({docs}) => {
                    const budget = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    });
                    setBudget(budget);
                    if (month) {
                        const filteredBudget = budget.filter(el => {
                            return el.month === month.number;
                        })
                        setFilteredBudget(filteredBudget)
                    } else {
                        setFilteredBudget(budget)
                    }
                })
            } catch (error) {
                
            }

        }

    }, [appState.userId, month])

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }
    }

    return (
        <div>   

            <div className="card card-header bg-light mt-2" onClick={toggle}>
                <div>{categoryName} <span className="float-right"><i className={`fas fa-chevron-${show ? "down" : "up"}`}></i></span></div>
            </div>

            <br />
            <div className="card card-body">
                {show && (
                    <React.Fragment>
                        {filteredBudget?.map((budgetEl, index) => {
                            return (
                                <div key={index} className="pt-2">
                                    <div>
                                        <span>{dateFormatterShort(budgetEl.date)} {budgetEl.description}</span>
                                        <span className={type === "expense" ? "text-danger float-right" : "text-success float-right"}>{budgetEl.sum}</span>
                                        <Link to={`/budget/edit/${budgetEl.id}`}> <i className="fas fa-edit text-primary"></i> </Link>
                                    </div>
                                    <hr />
                                </div>
                            )
                        })}

                    </React.Fragment>
                )
                


                }
                <div>
                    <div>
                        <span className="font-weight-bold">Sum</span>
                        <span className={type === "expense" ? "text-danger float-right font-weight-bold" : "text-success float-right font-weight-bold"}>{totalIncomeCalculator(filteredBudget)}</span>
                    </div>
                    {!month && <AddTotalExpensesCategory type={type} categoryName={categoryName} categoryId={categoryId} sum={totalIncomeCalculator(filteredBudget)} />}
                    <hr />
                </div>
            </div>
        </div>
    )

}
export default SingleCategory